module.exports = __webpack_public_path__ + "img/img-tabs-1-3.aa1c6219.svg";